const Drinks = () => {
	return <div>Drinks</div>;
};
export default Drinks;
